export default __webpack_public_path__ + "static/media/a038-5.c391de33.svg";